// @flow

import { AceService } from '~/services';

export const resolvers = {
  Query: {
    elevateTokens: async (): Promise<?ElevateTokens> => {
      const elevateTokens = await AceService.getElevateTokens();
      let data = null;

      if (elevateTokens) {
        data = {
          ...elevateTokens,
          __typename: 'ElevateTokens',
        };
      }

      return data;
    },
  },
  Mutation: {
    elevateTokensMutation: async (
      // $FlowIssue
      _, // eslint-disable-line no-unused-vars
      { values }: ElevateTokensInputMutation,
    ): Promise<MessagePayload> => {
      await AceService.setElevateTokens(values);

      return {
        code: 0,
        message: 'Done',
        __typename: 'MessagePayload',
      };
    },
  },
};
